/** 运行环境：development | test | production */
export type AppEnv = 'development' | 'test' | 'production';

const rawEnv = import.meta.env.VITE_APP_ENV ?? import.meta.env.MODE;

export const appEnv: AppEnv =
  rawEnv === 'test' || rawEnv === 'production' || rawEnv === 'development'
    ? rawEnv
    : 'development';

export const isProduction = appEnv === 'production';
export const isTest = appEnv === 'test';
export const isDevelopment = appEnv === 'development';

export const appTitle = import.meta.env.VITE_APP_TITLE ?? 'Hyxino 科技门户';

/** 前台 CMS API */
export const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? '/api';

/** 管理端 sys-api */
export const sysApiBaseUrl = import.meta.env.VITE_SYS_API_BASE_URL ?? '/sys-api';
